// client/src/modules/crm/index.ts
import type { ModuleManifest } from '../types';
import { navItems } from './nav';
import { routes } from './routes';

/**
 * CRM module manifest (P1)
 *
 * Full sales funnel from cold research through closed deal.
 * Fully migrated to module registry with lazy-loaded routes.
 */
export const crmModule: ModuleManifest = {
  id: 'P1',
  name: 'Sales',
  shortName: 'Sales',
  description: 'Full sales funnel from prospecting through closed deals',
  icon: '👥',
  status: 'live',
  urlPrefix: '/crm',
  routes,
  navItems,
};

export default crmModule;
